import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useSnackbar } from "notistack";

import { useLoadingScreen } from '../../Store/LoadingManager';

import QueryBuilderHelper from "../../Utilities/Helpers/QueryBuilderHelper";

import { CachingEnum } from "../../Utilities/Enums/CachingEnum";

import { ErrorMessage, SuccessMessage } from "../../Constants/Messages";

import { GetDashboard, GetDashboardNotices } from "../../Api/Service/Dashboard/dashboardService";

//q_queryKey: any, params: any
// export function useDashboardHook(q_queryKey: any, params: any, runInitialFetch: boolean = true) {
export function useDashboardHook(runInitialFetch: boolean = true) {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();
    let { loading, setLoading } = useLoadingScreen();
    const fileBaseUrl = `${process.env.REACT_APP_API_URL}/api/`;

    // Initial fetch
    const { data, fetchStatus } = useQuery({
        queryKey: [CachingEnum.DASHBOARD],
        queryFn: () => getDashboardNotices({}), //TODO
        enabled: runInitialFetch,
    });

    const getDashboardNotices = async (params: any) => {
        let _data;
        // const responseData = await GetDashboardNotices(QueryBuilderHelper.BuildQueryString(params));
        const responseData = await GetDashboardNotices();

        if (responseData?.isSuccess) {
            _data = responseData?.data
        } else {
            enqueueSnackbar(responseData?.message ?? (responseData?.data?.message ?? ErrorMessage.PROBLEM_FETCHING_DATA), { variant: 'error' })
        }

        return _data;
    }

    return { data, fetchStatus }
}